import React, { useRef, useState } from "react"
// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    Button
} from "reactstrap";
// core components
import Header from "../../../../components/headers/Header";
import LoadingIndicator from "../../../../components/ui/LoadingIndicator";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
import * as Helper from "../../../../utils/Helper";
import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../../../redux/screens/admin/partner/user/EditRedux";
import AuthorizedScreen from "../../../../components/base/AuthorizedScreen";
import { NavigationService, NavigateActionTypes } from "../../../../navigation";
import UIDs from "../../../../UIDs";

const uid = UIDs.screens.admin.partner.user.edit;

class EditScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.SAVE_PARTNER_USER_ASYNC]: { done: this._handleSavePartnerUserAsyncDone, error: this._handleAsyncActionError },
            [ActionTypes.CREATE_PARTNER_USER_ASYNC]: { done: this._handleCreatePartnerUserAsyncDone, error: this._handleAsyncActionError }
        };
    }

    localVars = {
        navParams: {}
    };

    constructor(props) {
        super(props);

        this.localVars.navParams = NavigationService.getNavParams(props);
    }

    componentDidMount() {
        super.componentDidMount();

        const { id, partnerId } = this.localVars.navParams;
        if (id)
            this.props.loadScreenViewAsync(id);
        else
            this.props.createPartnerUser(partnerId);
    }

    render() {
        const { partnerUser, isCreated } = this.props.localState;

        return (
            <>
                <Header />
                <Container className="mt--7" fluid>
                    <Row>
                        <div className="col">
                            {!partnerUser || this.isActionExecuting(ActionTypes.LOAD_SCREEN_VIEW_ASYNC)
                                ? <LoadingIndicator />
                                : <EditForm
                                    {...this.props}
                                    partnerUser={partnerUser}
                                    isCreated={isCreated}
                                    onCancel={this._handleCancelEdit}
                                    onSave={this._handleSavePartnerUser}
                                    isDisabled={this.isActionExecuting(ActionTypes.SAVE_PARTNER_USER_ASYNC) || this.isActionExecuting(ActionTypes.CREATE_PARTNER_USER_ASYNC)}
                                />
                            }
                        </div>
                    </Row>
                </Container>
            </>
        );
    }

    _handleSavePartnerUser = (data) => {
        confirmAlert({
            title: this.props.t("confirmToSave"),
            message: this.props.t("sureToDo"),
            buttons: [
                {
                    label: this.props.t("yes"),
                    onClick: () => {
                        data = { ...data, partnerId: (this.props.partner ? this.props.partner.id : null) }
                        if (this.props.localState.isCreated) {
                            let sha256 = require("crypto-js/sha256");
                            let passwordHash = sha256(data.password).toString();
                            data = { ...data, password: passwordHash }
                            this.props.createPartnerUserAsync(data);
                        } else {
                            this.props.savePartnerUserAsync(data);
                        }
                    }
                },
                {
                    label: this.props.t("no")
                }
            ]
        });
    }

    _handleConfirmCreate = () => {
        confirmAlert({
            title: this.props.t("confirmToCreate"),
            message: this.props.t("sureToDo"),
            buttons: [
                {
                    label: this.props.t("yes"),
                    onClick: () => {
                        this.props.updateIsCreated();
                    }
                },
                {
                    label: this.props.t("no"),
                    onClick: () => {
                        this._handleCancelEdit();
                    }
                }
            ]
        });
    }

    _handleCancelEdit = () => {
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    }

    _handleSavePartnerUserAsyncDone = () => {
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    }

    _handleCreatePartnerUserAsyncDone = () => {
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    }

    _handleAsyncActionError = (action) => {
        if (action.error.code !== 100) {
            this.displayError(action.error);
        }
        if (!this.props.localState.partnerUser.id && action.error.code === 100) {
            this._handleConfirmCreate();
        }
    }
}

function EditForm(props) {
    const { partnerUser, isCreated } = props;
    const { id, partnerId, email, role, firstName, lastName } = partnerUser;
    const { register, handleSubmit, errors, clearError } = useForm();
    const submitRef = useRef();
    const [state_password, setstate_password] = useState("");

    const inputPassword = (e) => {
        var reg = new RegExp("^" + e.target.value + "$");
        setstate_password(reg);
    };

    return (
        <Card className="shadow">
            <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                    {isCreated ? 
                        <Col xs="8">
                            <h3 className="mb-0">{props.t("createPartnerUser")}</h3>
                        </Col>
                        :
                        <Col xs="8">
                            <h3 className="mb-0">{props.t("partnerUser")}</h3>
                        </Col>
                    }
                    <Col className="text-right" xs="4">
                        <Button
                            color="info"
                            onClick={() => submitRef.current.click()}
                            disabled={props.isDisabled}
                            size="sm">
                            {props.t("save")}
                        </Button>&nbsp;
                        <Button
                            color="default"
                            onClick={props.onCancel}
                            disabled={props.isDisabled}
                            size="sm">
                            {props.t("cancel")}
                        </Button>
                    </Col>
                </Row>
            </CardHeader>
            <CardBody>
                <form onSubmit={handleSubmit(props.onSave)}>
                    <input name="id" hidden type="text" className="form-control" defaultValue={id} ref={register} />
                    <input name="partnerId" hidden type="text" className="form-control" defaultValue={partnerId} ref={register} />
                    <div className="pl-lg-4">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("email")}</label>
                                    <input name="email" type="text" className="form-control-alternative form-control" defaultValue={email}
                                        ref={register({
                                            required: props.t("fieldIsRequired"),
                                            pattern: {
                                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                                message: props.t("invalidEmailAddress"),
                                            },
                                            validate: {
                                                message: value => {
                                                    if (value.length > 50) {
                                                        return props.t("invalidLength", { name: props.t("email"), max: 50 });
                                                    }
                                                    return clearError();
                                                }
                                            }
                                        })} />
                                    {errors.email && <span className="text-danger">{errors.email.message}</span>}
                                </div>
                            </div>
                            {(id != null || isCreated) ?
                                <div className="col-lg-6">
                                    <div className="form-group">
                                        <label className="form-control-label">{props.t("fullName")}</label>
                                        <input
                                            className="form-control-alternative form-control"
                                            name="firstName"
                                            type="text"
                                            ref={register({ 
                                                required: props.t("fieldIsRequired"),
                                                validate: {
                                                    message: value => {
                                                        if (value.replace(/\s/g, "").length === 0) {
                                                            return props.t("fullNameSpace");
                                                        }
                                                        if (value.length > 20) {
                                                            return props.t("invalidLengthH", { name: props.t("fullName"), max: 20 });
                                                        }
                                                        if(Helper.existsSepcialContent(value)){
                                                            return props.t("invalidContent");
                                                        }
                                                        return clearError();
                                                    }
                                                }
                                            })}
                                            defaultValue={firstName}
                                        />
                                        {errors.firstName && <span className="text-danger">{errors.firstName.message}</span>}
                                    </div>
                                </div>
                                :
                                <div className="col-lg-6">
                                    <div className="form-group">
                                        <label className="form-control-label">{props.t("role")}</label>
                                        <select name="role" defaultValue={role} className="form-control-alternative form-control" ref={register({ required: props.t("fieldIsRequired") })}>
                                            <option value={2}>{props.t("assistant")}</option>
                                            <option value={1}>{props.t("teacher")}</option>
                                            <option value={0}>{props.t("manager")}</option>
                                        </select>
                                        {errors.role && <span className="text-danger">{errors.role.message}</span>}
                                    </div>
                                </div>
                            }                           
                        </div>
                        {(id != null || isCreated) && 
                            <>
                                {id == null && <div className="row">
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label className="form-control-label">{props.t("inputPassword")}</label>
                                            <input 
                                                name="password"
                                                className="form-control-alternative form-control"
                                                onChange={(e) => inputPassword(e)} 
                                                type="password" 
                                                ref={register({
                                                    required: props.t("fieldIsRequired"),
                                                    pattern: {
                                                        value: /^(?=.*[A-Za-z])(?=.*\d)[\d\D]{8,14}$/,
                                                        message: props.t("inputInvalidPassword"),
                                                    },
                                                })}
                                                maxLength={15}
                                            />
                                            {errors.password && <span className="text-danger">{errors.password.message}</span>}
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label className="form-control-label">{props.t("inputPasswordAgain")}</label>
                                            <input
                                                name="passwordAgain"
                                                className="form-control-alternative form-control"
                                                type="password"
                                                ref={register({
                                                    required: props.t("fieldIsRequired"),
                                                    pattern: {
                                                        value: state_password,
                                                        message: props.t("passwordError"),
                                                    },
                                                })}
                                                maxLength={15}
                                            />
                                            {errors.passwordAgain && <span className="text-danger">{errors.passwordAgain.message}</span>}
                                        </div>
                                    </div>                      
                                </div>}
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label className="form-control-label">{props.t("role")}</label>
                                            <select name="role" defaultValue={role} className="form-control-alternative form-control" ref={register({ required: props.t("fieldIsRequired") })}>
                                                {/* <option value={0}>{props.t("manager")}</option> */}
                                                <option value={1}>{props.t("teacher")}</option>
                                            </select>
                                            {errors.role && <span className="text-danger">{errors.role.message}</span>}
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                    <input ref={submitRef} type="submit" hidden />
                </form>
            </CardBody>
        </Card>
    );
}

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId,
        partner: state.session.partner
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: id => dispatch(Actions.loadScreenViewAsync(id)),
        savePartnerUserAsync: vo => dispatch(Actions.savePartnerUserAsync(vo)),
        createPartnerUser: partnerId => dispatch(Actions.createPartnerUser(partnerId)),
        updateIsCreated: () => dispatch(Actions.updateIsCreated()),
        createPartnerUserAsync: vo => dispatch(Actions.createPartnerUserAsync(vo)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(EditScreen));